// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesClaimStatusCodeClaimStatusResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesClaimStatusCodeClaimStatusResponse.attributeTypeMap;
    }
}
ClaimV1TypesClaimStatusCodeClaimStatusResponse.discriminator = undefined;
ClaimV1TypesClaimStatusCodeClaimStatusResponse.additionalProperties = false;
ClaimV1TypesClaimStatusCodeClaimStatusResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1TypesClaimStatusCodeClaimStatusResponse.js.map